import { render, staticRenderFns } from "./BidsAutocomplete.vue?vue&type=template&id=20390895&"
import script from "./BidsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BidsAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./BidsAutocomplete.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports